export const USER_TYPES = {
  CHOWA: {
    id: 'chowa',
    label: '調和工業 青柳様',
    dashboardPath: '/chowa/main',
    defaultRedirect: '/chowa/main',
    iconPath: '/user_icon/CHOWA_C.jpg'
  }
};

export const getRedirectPath = (userType) => {
  const config = Object.values(USER_TYPES).find(type => type.id === userType);
  return config ? config.defaultRedirect : '/error';
};

export const getUserTypeLabel = (userType) => {
  const config = Object.values(USER_TYPES).find(type => type.id === userType);
  return config ? config.label : 'Unknown User';
};

export const isValidUserType = (userType) => {
  return Object.values(USER_TYPES).some(type => type.id === userType);
};

export const getUserIcon = (userType) => {
  const config = Object.values(USER_TYPES).find(type => type.id === userType);
  return config?.iconPath || null;
};
